var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20,11l-2.79-2.79L4.71,20.71l-1.41-1.41L15.79,6.79l-2.79-2.79h7v7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrow);
export default __webpack_public_path__ + "static/1772534745/media/icon-arrow.6d76a504084ae571042cbea4276c216a.svg";
export { ForwardRef as ReactComponent };